<template>
  <div>
    <div class="row">
      <h2>Lexicon suggestions list <b>({{this.desc}})</b></h2>
        <span style="position: relative; left: 15%; top: 10%;">
          Displays and manages suggestions list for transcribe lexicon. click "<u>New suggestion</u>" to add a new suggestion to the lexicon builds, click "<u>View Words</u>" to go to words list.
        </span>
    </div>

    <div v-if="this.displayFlash" class="alert alert-success" role="alert">
      New suggestions request have been submitted successfully
    </div>

    <div class="row float-right">
      <div class="col-md-12"><br />
        <label class="btn btn-success" @click.stop="onAddSuggestion()">
          New suggestions
        </label>&nbsp;

        <label class="btn btn-info" @click.stop="navigateToLexiconWordsList()">
          View words
        </label>&nbsp;
      </div>
    </div>

    <div class="row d-flex justify-content-center">
      <div v-if="this.requestCompleted && this.rows.length === 0">
        Builds list is empty, click on "Manage suggestion" to add to the list.<br />
      </div>
    </div>

    <div v-if="this.requestCompleted && this.rows.length === 0" class="row d-flex justify-content-center">
      <img src="@/assets/no-data.png" />
    </div>

    <div v-if="this.rows.length > 0">
      <grid :styles="gridStyle" :cols="cols" :rows="rows" :sort="true" :pagination="pagination" :search="search"></grid>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import Grid from 'gridjs-vue'
import router from '../router'

export default {
  props: {
  },
  components: {
    Grid
  },
  data () {
    return {
      desc: {},
      rows: [],
      requestCompleted: false,
      displayFlash: false,
      uploadURL: '',
      groupId: 0,
      pagination: true,
      search: true,
      gridStyle: {
        table: {
          border: '3px solid #ccc'
        },
        th: {
          'background-color': 'rgba(0, 0, 0, 0.1)',
          color: '#000',
          'border-bottom': '3px solid #ccc',
          'text-align': 'center'
        },
        td: {
          'text-align': 'center'
        }
      },
      cols: [
        {
          name: 'Suggestion ID',
          formatter: (cell, row) => {
            let displayHtml = '<span style="cursor: pointer; color: green"><u>' + cell + '</u></span>'
            if (!cell) {
              displayHtml = '<span style="color: orange"><u>Suggestion is in progress, No ID available.</u></span>'
            }
            return this.$gridjs.html(displayHtml)
          }
        },
        {
          name: 'Request Date',
          formatter: (cell) => this.$gridjs.html('<span><u>' + cell + '</u></span>')
        },
        {
          name: 'Display Suggestions',
          formatter: (cell) => {
            const linkAction = this.$gridjs.h(
              'span',
              { onClick: () => this.onViewSuggestion(cell) },
              this.$gridjs.html('<label class="btn btn-primary">View Suggestion Items</label>')
            )
            return [linkAction]
          }
        }
      ]
    }
  },
  mounted: function () {
    this.groupId = this.$route.params.id

    apiClient.get('/api/lexicons/item/' + this.groupId).then((response) => {
      this.desc = response.data.group[0].lexicon_description
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })

    apiClient.get('/api/lexicon/suggestions/list/' + this.groupId).then((response) => {
      response.data.forEach((item, key) => {
        this.rows.push([
          item.request_id,
          item.request_date,
          item.id
        ])
      })
      this.requestCompleted = true
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })
  },
  methods: {
    navigateToLexiconWordsList: function () {
      router.push({ name: 'LexiconWords', params: { id: this.groupId } })
    },
    onAddSuggestion: function (event) {
      apiClient.get('/api/lexicon/suggest/' + this.groupId).then((response) => {
        if (response.data.status) {
          this.displayFlash = true
          setTimeout(() => {
            this.displayFlash = false
          }, 10000)
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    },
    onViewSuggestion: function (id) {
      router.push({ name: 'LexiconSuggestionWords', params: { id: id } })
    }
  }
}
</script>
